import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Title } from "@angular/platform-browser";

import { BillingService } from '../../../../services/billing/billing.service';
import { OthersService } from '../../../../services/others/others.service';

@Component({
  selector: 'app-view-invoice-receipt-pdf',
  templateUrl: './view-invoice-receipt-pdf.component.html',
  styleUrls: ['./view-invoice-receipt-pdf.component.scss']
})
export class ViewInvoiceReceiptPdfComponent implements OnInit {

  ptypename = { 1: 'Monthly', 2: 'Annual' };
  //invoicetype = { 1: 'Invoice', 2: 'Receipt' };
  receiptID = "";
  compID = "";

  x: any = [];

  address1: any;
  address: string = "";
  email: string = "";
  tel: string = "";
  regname: string = "";

  payment: any = {};
  trans: any = {};

  pdftitle = ""

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private billingService: BillingService,
    private otherService: OthersService
  ) {
    this.receiptID = this.route.snapshot.paramMap.get('rid');
    this.compID = this.route.snapshot.paramMap.get('compid');

    let title = 'Invoice/Receipt Preview';
    this.titleService.setTitle(title);
  }

  ngOnInit() {
    this.getAddress();
    
  }

  ngAfterViewInit() {
    this.getInvoice();
  }

  getAddress() {
    this.billingService.getBillingAddress(this.compID).then((res: any) => {
      //console.log("Address: " + JSON.stringify(res));
      if (res.status == "OK") {
        let address = res.data;
        this.address1 = address;
        if (address) {

          this.address = address.address;
          this.regname = address.regname;
          this.email = address.email;
          this.tel = address.tel;

          /*let country = this.otherService.getCountryCodeFromPhone(address.tel);
          if (country != '') {
            this.selectedCountry = country;
          }*/

        }
      }
    });
  }

  getCurrentTransaction(tid) {
    /*this.billingService.getPayment(this.compID, tid).then((res: any) => {
      //console.log('PP=' + JSON.stringify(res))
      if (res.status == 'OK') {
        let data = res.data;

        if (data.p) {
          this.payment = data.p;
        }

        if (data.t) {
          this.trans = data.t;
        }
      }
    });*/
  }

  getInvoice() {
    this.billingService.getInvoice(this.compID, this.receiptID).then((res: any) => {
      //console.log(JSON.stringify(res))
      if (res.status == 'OK') {

        this.x = res.data;

        if (this.x.type == '2') {
          this.pdftitle = "Receipt";
          this.getCurrentTransaction(this.x.payid);
        }
        else if (this.x.type == '1'){
          this.pdftitle = "Invoice";
        }


        window.print();
      }
    });
  }

  parseDate(date: string, format: string) {
    return this.otherService.parseDate(date, format);
  }

}
